export default "__VITE_ASSET__B9wDk68Q__"